import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Data } from '@models/data.model';

export const ID = 0;

export const adapter: EntityAdapter<Data> = createEntityAdapter<Data>({
    selectId: () => ID
});

export interface State extends EntityState<Data> {
    loading: boolean;
    error?: any;
}

export const initialState: State = adapter.getInitialState({
    loading: false,
    error: null,
    entities: {
        [ID]: {}
    }
});
